import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: { type: "settings", showCardModal: false, flag: 2, cardContentType: "",registeredUser: null },
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setType: (state, { payload }) => {
            state.data.type = payload
        },
        setCardModalState: ((state, { payload }) => {
            state.data.showCardModal = payload
            state.data.flag = state.data.flag + 1;
        }),
        setCardContentType: (state, { payload }) => {
            state.data.cardContentType = payload;
        },
        setSelectedSubscriptionPrice: (state, { payload }) => {
            state.data.selectedSubscriptionPrice = payload;
        },
        setRegisteredUser: (state, { payload }) => {
            state.data.registeredUser = payload;
        }
    },
});

export const { setType, setCardModalState, setCardContentType, setSelectedSubscriptionPrice,setRegisteredUser } = userSlice.actions;
export default userSlice;